import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';

@Directive({ selector: '[appStickyStateIo]', standalone: false })
export class StickyStateDirective implements AfterViewInit, OnDestroy {
  @Output() stuckChange = new EventEmitter<boolean>();

  private observer?: IntersectionObserver;
  private sentinel?: HTMLElement;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    // Insert sentinel before the sticky element
    this.sentinel = document.createElement('div');
    this.sentinel.style.height = '1px';
    this.sentinel.style.marginTop = '-1px'; // so the crossover is precise
    this.sentinel.style.pointerEvents = 'none';
    this.el.nativeElement.parentElement?.insertBefore(
      this.sentinel,
      this.el.nativeElement,
    );

    // respect CSS top offset on the sticky element
    const top = parseFloat(getComputedStyle(this.el.nativeElement).top || '0');

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const stuck = entry.intersectionRatio === 0; // sentinel has crossed the top edge
        this.el.nativeElement.classList.toggle('is-stuck', stuck);
        this.stuckChange.emit(stuck);
      },
      {
        root: null,
        threshold: 0,
        rootMargin: `-${(Number.isFinite(top) ? top : 0) + 1}px 0px 0px 0px`, // +1px tolerance
      },
    );

    this.observer.observe(this.sentinel);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
    this.stuckChange.complete();
    if (this.sentinel?.parentElement) {
      this.sentinel.parentElement.removeChild(this.sentinel);
    }
  }
}
